<!-- 文件组件 -->
<template>
    <div>
        <el-upload
            :limit="limit"
            :data="uploadData"
            :action="url"
            :headers="uploadHeaders"
            :on-success="uploadSuccess"
            :before-upload="beforeUpload"
            :on-error="uploadErr"
            :on-remove="handleRemove"
            :multiple="multiple"
            accept="image/*"
            list-type="picture"
            :file-list="fileList"
        >
            <el-button size="small" class="btn-primary">点击上传</el-button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span slot="tip" class="el-upload__tip">只能上传jpg/png文件,不能大于10M</span>
        </el-upload>
        <ul class="el-upload-list el-upload-list--picture">
            <li :key="index" v-for="(item, index) in havedList" :tabindex="index" class="el-upload-list__item is-success">
                <img :src="downloadUrl + item" alt="" class="el-upload-list__item-thumbnail" />
                <a class="el-upload-list__item-name">
                    <i class="el-icon-document"></i>
                </a>
                <label class="el-upload-list__item-status-label">
                    <i class="el-icon-upload-success el-icon-check"></i>
                </label>
                <i class="el-icon-close" @click="handleRemove(item, index)"></i>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'uploadFile',
    components: {},
    props: {
        type: {
            type: String
        },
        limit: {
            type: Number,
            default: 999
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            downloadUrl: this.$util.QN_URL_BASE,
            havedList: [], // 原来已有的图片
            fileList: [],
            url: '/api/UploadFile/UploadSingle',
            uploadData: {
                key: this.type,
                isPrivate: false
            },
            uploadHeaders: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            }
        };
    },
    mounted() {},
    methods: {
        // 初始化文件列表
        initfileList(images) {
            if (images) {
                if (typeof images == 'string') {
                    this.havedList.push(images);
                } else {
                    this.havedList = [...images];
                }
            }
        },
        uploadSuccess(res) {
            this.$emit('uploadSuccess', res.fileUrl);
        },
        uploadErr() {
            this.$util.errorMsg('上传失败');
        },
        beforeUpload(file) {
            return this.$util.uploadCheck(file);
        },
        clearData() {
            this.fileList = [];
            this.havedList = [];
        },
        handleRemove(file, index) {
            let _file;
            if (file.response) {
                _file = file.response.fileUrl;
                this.$emit('handleRemove', _file);
            } else {
                _file = file.ImgUrl;
                this.$emit('handleRemove', _file);
                this.havedList.splice(index, 1);
            }
        }
    }
};
</script>
<style lang="less" scoped></style>
